module.exports = __webpack_public_path__ + "static/media/land-rover_logo.e4bf9840.png";